// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__TUwYj","circle":"Spinner_circle__1gtrv","shadow":"Spinner_shadow__XQqye"};